import React from 'react';
import { observer } from 'mobx-react';
import { bosLandingPageTrackingEvents } from 'integrations/segment/tracking-events';
import { StyledButton } from './styles';

interface LocationButtonInterface {
  className?: string;
  onSearch?: (locationShortId?: string) => void;
  landing_page_name?: string;
  locationShortId?: string;
  order_allowed?: string;
  external_url?: string;
}

export const LocationButton: React.FC<LocationButtonInterface> = ({
  className = '',
  onSearch = () => null,
  landing_page_name = '',
  locationShortId = '',
  order_allowed = '',
  external_url = '',
}) => (
  <StyledButton
    className={className}
    type="primary"
    onClick={() => {
      if (external_url) {
        bosLandingPageTrackingEvents.trackClickExternalLocationCodeButtonLandingPage({ external_url });
        window.location.href = external_url;
      } else {
        bosLandingPageTrackingEvents.trackClickLocationCodeButtonLandingPage({ locationShortId });
        onSearch(locationShortId);
      }
    }}
    disabled={order_allowed === 'off'}
    data-testid={`location-button-${locationShortId}`}
  >
    {landing_page_name ? landing_page_name?.toUpperCase() : locationShortId?.toUpperCase()}
    {order_allowed === 'off' ? ' (Currently Unavailable)' : ''}
  </StyledButton>
);

export default observer(LocationButton);
